import React from 'react';

const Checkout = () => {
  return (
    <section className="checkout">
      <div className="container">
        <div className="checkout-card">
          <h2 className="checkout-title">GARANTA SUA VAGA AGORA!</h2>
          
          <div className="checkout-pricing">
            <div className="checkout-old-price">de R$ 147,00</div>
            <div className="checkout-price-label">Por Apenas</div>
            <div className="checkout-installment">
              12X DE <span className="checkout-value">R$ 8,06</span>
            </div>
            <div className="checkout-cash">Ou R$ 77,90 a vista</div>
          </div>
          
          <div className="checkout-benefits">
            <div className="checkout-benefit">Acesso imediato</div>
            <div className="checkout-benefit">20+ aulas praticas</div>
            <div className="checkout-benefit">Certificado incluso</div>
            <div className="checkout-benefit">Suporte direto</div>
            <div className="checkout-benefit">Bonus especiais</div>
            <div className="checkout-benefit">Garantia de 7 dias</div>
          </div>
          
          <a href="https://pay.kiwify.com.br/TXv8v09" target="_blank" rel="noopener noreferrer" className="checkout-cta-button">
            Sim, quero comecar agora!
          </a>
          
          <div className="checkout-security">
            <span>Compra 100% segura</span>
            <span>Ambiente protegido</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Checkout;
